import './index.scss';
import "daterangepicker/daterangepicker.css";
var daterangepicker = require("daterangepicker");
import { __ } from '@wordpress/i18n';
import { createElement } from '@wordpress/element'
import React, { Component, CSSProperties } from "react";

// To assign event


class Datepickers extends Component {

  constructor(props) {
    super(props);
    this.state = {
      start : moment(new Date(wisdm_ld_reports_common_script_data.start_date)),
      end   : moment(new Date(wisdm_ld_reports_common_script_data.end_date)),
    }

    this.durationUpdated               = this.durationUpdated.bind(this);
  }

  componentDidMount() {
    jQuery('#js-daterangepicker-predefined').daterangepicker({
      startDate: this.state.start,
      endDate: this.state.end,
      ranges: {
        'Today': [moment(), moment()],
        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
      maxDate:moment()
    }, durationUpdatedCallback);

    durationUpdatedCallback(this.state.start, this.state.end);
    document.addEventListener('duration_updated', this.durationUpdated);
  }

  durationUpdated(event) {
    this.setState(
      {
        start:moment(new Date(event.detail.startDateObject)),
        end:moment(new Date(event.detail.endDateObject))
      }
      );
  }

  render(){
    return (
      <div class="wisdm-learndash-reports-date-filters-container"> 
        <div class="wisdm-ld-reports-title">
            <div class="report-title">
                <h2>{__('Reports Dashboard', 'learndash-reports-by-wisdmlabs')}</h2>
                <span>{this.state.start.format('MMM D, YYYY')} -  {this.state.end.format('MMM D, YYYY')}</span>
            </div>
        </div>
        <div class="wisdm-ld-reports-date-range-picker">
            <div class="date-filter-label">
                <span>{__('SHOWING DATA FOR ', 'learndash-reports-by-wisdmlabs')}</span>
            </div>
            <div id="js-daterangepicker-predefined">
                <div class="dashicons dashicons-calendar-alt"> </div>
                <span>{this.state.start.format('MMM D, YYYY')} -  {this.state.end.format('MMM D, YYYY')}</span>
            </div>
        </div>
      </div>
    );
  }
}

function durationUpdatedCallback(start, end) {
  // To trigger the Event
  const durationEvent = new CustomEvent("duration_updated", {
      "detail": {"startDate":start.unix(),"endDate":end.unix(), "startDateObject": start, "endDateObject":end }
    });
  document.dispatchEvent(durationEvent);
}

document.addEventListener("DOMContentLoaded", function(event) {

  function durationUpdatedOldCallback(start, end) {
    // To trigger the Event
    jQuery('#js-daterangepicker-predefined span').html(start.format('MMM D, YYYY') + ' - ' + end.format('MMM D, YYYY'));
    jQuery('.wisdm-ld-reports-title .report-title>span').text(start.format('MMM D, YYYY') + ' - ' + end.format('MMM D, YYYY'));

    const durationEvent = new CustomEvent("duration_updated", {
        "detail": {"startDate":start.unix(),"endDate":end.unix(), "startDateObject": start, "endDateObject":end }
      });
    document.dispatchEvent(durationEvent);
  }

  let elem = document.getElementsByClassName('wisdm-learndash-reports-date-filters front');
  if (elem.length>0) {
    ReactDOM.render(React.createElement(Datepickers), elem[0]); 
  } else {
    //Backword compatibility with version < 1.0.3
    var start = moment(new Date(wisdm_ld_reports_common_script_data.start_date));
    var end   = moment(new Date(wisdm_ld_reports_common_script_data.end_date));
    jQuery('.report-title > span').text(start.format('MMM D, YYYY') + ' - ' + end.format('MMM D, YYYY'));
        // To trigger the Event

    jQuery('#js-daterangepicker-predefined').daterangepicker({
      startDate: start,
      endDate: end,
      ranges: {
        'Today': [moment(), moment()],
        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
      maxDate:moment()
    }, durationUpdatedOldCallback);

    durationUpdatedOldCallback(start, end);
  }   
});

  
